module.exports = require('./lib/linkify-string').default;
